import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import { mapId, mapName } from 'helpers/react_select_helpers';
import UserIconList from 'components/user_icon_list';

import AvailableIntegrations from './available_integrations';
import ActiveIntegrations from './active_integrations';

import './integrations.scss';

export default class IntegrationsTab extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.arrayOf(PropTypes.shape({
      members: PropTypes.array.isRequired
    })).isRequired,
    calendarIntegration: PropTypes.object,
    calendars: PropTypes.array,
    clickToCallIntegration: PropTypes.object,
    contactImportReadyAt: PropTypes.string,
    contactIntegration: PropTypes.object,
    contactSyncAccess: PropTypes.bool,
    currentDatabase: PropTypes.object,
    currentUser: PropTypes.object.isRequired,
    googleIntegration: PropTypes.object,
    importCalendar: PropTypes.bool,
    paths: PropTypes.object.isRequired,
    pushContactsToSource: PropTypes.bool.isRequired,
    svnMember: PropTypes.bool,
  };

  state = {
    database: this.props.currentDatabase
  };

  handleDatabaseSelect = database => this.setState({ database });

  renderDatabaseSelector() {
    const { availableDatabases } = this.props;
    const { database } = this.state;

    const databaseText = database.members.length === 1 ? "User" : "Users";

    return (
      <div className="select-database">
        <h5>Select Database</h5>
        <div>
          <Select
            className="col-xs-4 pl-0"
            classNamePrefix="database-selector"
            getOptionLabel={mapName}
            getOptionValue={mapId}
            options={availableDatabases}
            value={database}
            onChange={this.handleDatabaseSelect}
          />
          <div className="users-list">
            <span>{database.members.length} {databaseText}</span>
            <UserIconList size="24px" users={database.members}/>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { availableDatabases, calendars } = this.props;

    const { database } = this.state;

    return (
      <div className="integrations-tab">
        {this.renderDatabaseSelector()}
        <div>
          <h2 className="database-name">{database.name} Integrations</h2>
          <ActiveIntegrations
            {...this.props}
            calendarsForImport={calendars}
            currentDatabase={database}
            databases={availableDatabases}
          />
          <AvailableIntegrations
            {...this.props}
            currentDatabase={database}
            databases={availableDatabases}
          />
        </div>
      </div>
    );
  }
}
